import React from "react";

export default function Privacy() {
    return (
        <main className="max-w-4xl mx-auto px-4 py-8">
            <h2 className="text-2xl font-bold mb-6">Privacy Notice</h2>
            <p className="text-sm text-slate-500 mb-6">Last updated September 05, 2022</p>

            <p className="mb-4">
                This privacy notice for Clayton Car Contracts Ltd ("Company", "we", "us", or "our")
                describes how and why we might collect, store, use, and/or share ("process") your information
                when you use our services ("Services").
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Summary of Key Points</h3>
            <ul className="list-disc ml-6 space-y-2 text-slate-700">
                <li>We may collect personal information when you interact with our Services.</li>
                <li>We do not receive information from third parties.</li>
                <li>We process information to provide and improve Services, communicate with you, and comply with law.</li>
                <li>We may share information in limited cases (e.g. vendors, business transfers).</li>
                <li>We implement technical and organisational safeguards to protect your data.</li>
                <li>You may have rights depending on your location (EEA, UK, etc.).</li>
            </ul>

            <h3 className="text-xl font-semibold mt-6 mb-3">1. What Information Do We Collect?</h3>
            <p className="mb-4">We collect personal information that you provide to us, including:</p>
            <ul className="list-disc ml-6 text-slate-700 mb-4">
                <li>Names</li>
                <li>Phone numbers</li>
                <li>Email addresses</li>
            </ul>
            <p className="mb-4">
                We also collect some information automatically (device details, IP address, browser type, usage data,
                location data, and cookies).
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">2. How Do We Process Your Information?</h3>
            <p className="mb-4">
                We process your data to provide Services, respond to inquiries, manage orders,
                communicate with you, and for security/fraud prevention.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">3. Legal Bases</h3>
            <p className="mb-4">
                We rely on Consent, Performance of Contract, Legal Obligations, and Vital Interests to process your data.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">4. When and With Whom Do We Share Your Information?</h3>
            <p className="mb-4">
                We may share data with vendors, consultants, service providers, or in connection with business transfers.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">5. Cookies & Tracking</h3>
            <p className="mb-4">
                We use cookies and similar technologies for site functionality, analytics, and advertising.
                You can manage preferences via your browser or cookie consent manager.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">6. Data Retention</h3>
            <p className="mb-4">
                We retain data only as long as needed for our purposes or as required by law, after which it will be deleted or anonymised.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">7. Security</h3>
            <p className="mb-4">
                We apply technical and organisational measures to protect data, though no system is 100% secure.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">8. Children’s Data</h3>
            <p className="mb-4">
                We do not knowingly collect or market to children under 18. If we discover such data, we will delete it.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">9. Privacy Rights</h3>
            <p className="mb-4">
                Depending on your region, you may have rights to access, rectify, erase, restrict, or object to processing.
                You can exercise these rights by contacting us.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">10. Do-Not-Track</h3>
            <p className="mb-4">
                We do not currently respond to DNT signals as no standard has been adopted.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">11. Updates</h3>
            <p className="mb-4">
                We update this notice as necessary. Please check back regularly for changes.
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">12. Contact Us</h3>
            <p className="mb-4">
                Email: <a href="mailto:sean@contracthire.net" className="text-blue-600 underline">sean@contracthire.net</a><br/>
                Address: Clayton Car Contracts Ltd, Brook Farm Barn, Stafford, Marston ST18 9SX, UK
            </p>

            <h3 className="text-xl font-semibold mt-6 mb-3">Cookie Policy</h3>
            <p className="text-sm text-slate-500 mb-4">Last updated September 06, 2022</p>
            <p className="mb-4">
                We use cookies to make our website work, improve user experience,
                and support analytics and advertising. You may manage cookies via your
                browser or our consent manager.
            </p>
            <p className="mb-4">
                If you have any questions about cookies, email us at
                <a href="mailto:sean@contracthire.net" className="text-blue-600 underline"> sean@contracthire.net</a>.
            </p>
        </main>
    );
}
